function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Created by liushuai on 2019-11-15
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'mkui-fd';
import { getAbbrName, getColor } from './util';

function EnhancedAvatar(props) {
  var name = props.name;
  var newName = getAbbrName(name);
  var color = getColor(name);
  return React.createElement(Avatar, _extends({}, props, {
    style: {
      backgroundColor: color,
      verticalAlign: 'middle'
    }
  }), newName);
}

EnhancedAvatar.propTypes = {
  name: PropTypes.string
};
EnhancedAvatar.defaultProps = {
  name: ''
};
export default EnhancedAvatar;
//# sourceMappingURL=EnhancedAvatar.js.map
